module.exports = __webpack_public_path__ + "static/media/ic_summary.2ffd3973.svg";